import { CalendarDay, CalendarWeek, useDayPicker, WeeksProps } from "react-day-picker";
import { Box, Button, Typography } from "@mui/material";
import { Moon, Sun, Sunrise } from "lucide-react";
import { useDispatch } from "react-redux";
import { useContext, useMemo } from "react";
import { Dispatch } from "redux";

import { setViewFullCalendar } from "../../store/reducer";

import {
	canDisplayWeek,
	compareTwoDate,
	DayPickerContext,
	getShiftNameByNumber,
	isCurrentWeek,
} from "./CalendarUtils";

export default function RowVariant({ className, ...props }: WeeksProps) {
	const today = useMemo(() => new Date(), []);

	const { selected, setSelected, nurseCount } = useContext(DayPickerContext);
	const dayPicker = useDayPicker();

	const dispatch: Dispatch<any> = useDispatch();

	const _onChangeDay = (date: Date) => {
		setSelected?.(date);
		dispatch(setViewFullCalendar(false));
	};

	/**
	 * Obtenemos qué tantas enfermeras hay asignadas en un día y turno específico.
	 * @param date Fecha de los datos que queremos
	 * @param shiftNumber Donde 0: matutino, 1: vespertino, 2: nocturno
	 * @returns Cantidad de enfermeras
	 */
	const getCounting = (date: Date, shiftNumber: number): number => {
		const dateString: string = date.getFullYear() + "-" +
              String(date.getMonth() + 1).padStart(2, "0") + "-" +
              String(date.getDate()).padStart(2, "0");
		const dayInfo = nurseCount?.[dateString];
		if (dayInfo === undefined) return 0;

		const shiftInfo = dayInfo.find((day: any) =>
			day.schedule.includes(getShiftNameByNumber(shiftNumber)),
		);
		if (shiftInfo === undefined) return 0;

		return shiftInfo.value;
	};

	return (
		<tbody className={`${className}`}>
			{dayPicker.months[0].weeks.map((week: CalendarWeek) => {
				const days = week.days;

				return (
					<tr
						key={week.weekNumber}
						className={`rdp-week ${
							isCurrentWeek(week.weekNumber) ? "current-week" : ""
						} ${!canDisplayWeek(week) && "hidden-week"}`}
					>
						{days.map((day: CalendarDay) => {
							const { date, outside } = day;

							return (
								<td
									key={day.date.toString()}
									className={`rdp-day ${outside && "rdp-outside"}`}
									role="gridcell"
									data-day={`${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`}
									data-month={`${date.getFullYear()}-${date.getMonth()}`}
									data-outside={`${outside}`}
								>
									<Button
										key={day.date.toString()}
										onClick={outside ? undefined : () => _onChangeDay(date)}
										className={`rdp-day_button ${
											compareTwoDate(selected!, date)
												? "rdp-day_button--selected"
												: ""
										} ${
											!compareTwoDate(selected!, date) &&
											compareTwoDate(today, date)
												? "rdp-day_button--current"
												: ""
										}`}
										type="button"
										tabIndex={-1}
									>
										<Typography>{day.date.getDate()}</Typography>
										<Box className="rdp-day_button__options">
											<Box className="rdp-day_button__option">
												<Sunrise />
												<Typography>{getCounting(date, 0)}</Typography>
											</Box>
											<Box className="rdp-day_button__option">
												<Sun />
												<Typography>{getCounting(date, 1)}</Typography>
											</Box>
											<Box className="rdp-day_button__option">
												<Moon />
												<Typography>{getCounting(date, 2)}</Typography>
											</Box>
										</Box>
									</Button>
								</td>
							);
						})}
					</tr>
				);
			})}
		</tbody>
	);
}
